module.exports = __webpack_public_path__ + "img/icon_pig_count.734137be.svg";